<mat-dialog-content>
    <button class="buttonClose" color="white" matTooltip="{{ 'SIDEBAR_WIDGET.CLOSE' | translate }}"
        [mat-dialog-close]="true"><span class="material-icons">close</span>
    </button>
    <div class="container">
        <form flex [formGroup]="taskForm">
            <h2>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.TITLE' | translate }}</h2>
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.GOAL' | translate
                        }}</mat-label>
                    <textarea matInput type="text" formControlName="goal" autocomplete="off"></textarea>
                </mat-form-field>
            </field-holder>
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.ACTIVITIES' | translate
                        }}</mat-label>
                    <textarea matInput type="text" formControlName="activities" autocomplete="off"></textarea>
                </mat-form-field>
            </field-holder>
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.TIMEFRAME' | translate
                        }}</mat-label>
                    <input matInput [matDatepicker]="pickerStartDate" [min]="minFromDate" formControlName="timeframe"
                        (dateChange)="checkDate('timeframe',$event)" autocomplete="off" [max]="maxDate" />
                    <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartDate></mat-datepicker>
                </mat-form-field>
            </field-holder>
            <field-holder>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.RESPONSIBLE_PERSON' |
                        translate }}</mat-label>
                    <input matInput type="text" formControlName="responsiblePerson" maxlength="250"
                        autocomplete="off" />
                </mat-form-field>
            </field-holder>
            <form-footer>
                <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()" type="button"
                    class="form-footer__button form-footer__button--secondary">
                    {{ 'VS.FORM5.TASKS.CANCEL' | translate }}
                </button>
                <button *ngIf="!isEdit" mat-flat-button color="primary" type="button" (click)="addNewTask()"
                    class="form-footer__button form-footer__button--primary">
                    {{ 'VS.FORM5.TASKS.SUBMIT' | translate }}
                </button>
                <button *ngIf="isEdit" mat-flat-button color="primary" type="button" (click)="editTask()"
                    class="form-footer__button form-footer__button--primary">
                    {{ 'VS.EDIT' | translate }}
                </button>
            </form-footer>
        </form>
        <br />
    </div>
</mat-dialog-content>